// Vaanmathi
import React, { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";
import Footer from "./Footer/Footer";
import { FaBars, FaTimes } from "react-icons/fa";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const contentRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 992;
      setIsMobile(mobile);

      if (!mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div
      className="d-flex flex-column"
      style={{ height: "100vh", overflow: "hidden" }}
    >
      {/* Navbar - Fixed at top with high z-index */}
      <Navbar
        onToggleSidebar={toggleSidebar}
        sidebarOpen={sidebarOpen}
        style={{ zIndex: 1055 }}
        isMobile={isMobile}
        onHamburgerClick={() => setSidebarOpen(true)}
      />
      {/* Main Content Area */}
      <div
        className="d-flex flex-grow-1 position-relative"
        style={{
          marginTop: "60px",
          height: "calc(100vh - 60px)",
          overflow: "hidden",
        }}
      >
        {/* Sidebar - only for desktop */}
        {!isMobile && (
          <Sidebar
            isOpen={sidebarOpen}
            onClose={(forceClose = true) => {
              if (forceClose) setSidebarOpen(false);
              else setSidebarOpen(true); // expands sidebar when parent with submenu is clicked
            }}
            style={{
              zIndex: 1050,
              position: "relative",
              top: "0",
              left: "0",
              width: sidebarOpen ? "240px" : "70px",
              height: "100%",
              transition: "width 0.3s",
              background: "#fff",
            }}
          />
        )}

        {/* Mobile Hamburger Menu */}
        {isMobile && (
          <>
            {/* Hamburger icon in navbar (handled via Navbar props) */}
            {/* Mobile menu overlay */}
            {sidebarOpen && (
              <div
                style={{
                  position: "fixed",
                  top: "60px",
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0,0,0,0.3)",
                  zIndex: 2000,
                  display: "flex",
                  alignItems: "flex-start",
                }}
                onClick={closeSidebar}
              >
                <div
                  style={{
                    width: "240px",
                    background: "#fff",
                    height: "100vh",
                    boxShadow: "2px 0 8px rgba(0,0,0,0.1)",
                    padding: "1rem 0.5rem",
                    position: "relative",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      background: "none",
                      border: "none",
                      fontSize: "1.5rem",
                      cursor: "pointer",
                    }}
                    onClick={closeSidebar}
                    aria-label="Close menu"
                  >
                    <FaTimes />
                  </button>
                  <Sidebar isOpen={true} onClose={closeSidebar} />
                </div>
              </div>
            )}
          </>
        )}
        {/* Main Content */}
        <main
          className="flex-grow-1 d-flex flex-column"
          style={{
            marginLeft: !isMobile ? (sidebarOpen ? "240px" : "70px") : "0",
            transition: "margin-left 0.3s ease-in-out",
            height: "100%",
            overflow: "hidden",
            position: "relative",
            zIndex: 1000,
          }}
        >
          {/* Scrollable Content Area */}
          <div
            ref={contentRef}
            className="flex-grow-1 d-flex flex-column"
            style={{
              overflowY: "auto",
              overflowX: "hidden",
              height: "100%",
              backgroundColor: "#ffffffff",
              position: "relative",
            }}
          >
            {/* Content that will scroll */}
            <div style={{ flex: "1 0 auto" }}>{children}</div>
            {/* Footer that stays at bottom */}
            <Footer
              style={{
                flexShrink: 0,
                width: "100%",
              }}
            />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
